export default __webpack_public_path__ + "static/media/apply-default-curves.e5e66860.svg";